import { Injectable, Injector } from '@angular/core';

import { Relatie } from '../dto/relatie';
import { CrudService, Filter, FilterOperator } from '@mango/core';
import { Artikel } from '../dto/artikel';
import { map } from 'rxjs/operators';
import { DocumentDownloadResponse } from './projectregel.service';
import { SendMailing } from '../dto/sendMailing';
import { SendMailingResponse } from 'src/app/user/user.service';

@Injectable({ providedIn: 'root' })
export class RelatieService extends CrudService<Relatie> {

    constructor(injector: Injector) { super(Relatie, injector); }

    getRelatieFilter(): Filter<Relatie> {
        return new Filter<Relatie>(fb => [fb.equal(x => x.isRelatie,true)]);
    }

    getLeverancierFilter(): Filter<Relatie> {
        return new Filter<Relatie>(fb => [fb.equal(x => x.isLeverancier,true)]);
    }

    getProspectFilter(): Filter<Relatie> {
        return new Filter<Relatie>(fb => [fb.equal(x => x.isProspect,true)]);
    }

    downloadExcelFile(filter: Filter<Relatie>) {        
        let f = `filter=${encodeURIComponent(JSON.stringify(this.convertFilter(filter) ))}`;
        let query: string = `/api/dto/relatie/RelatieExport?${f}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));

    }

    bijwerkenOproepHistorie(id: Number) {        
        let query: string = `/api/dto/relatie/OproepHistorieBijwerken?Id=${id}`;
        return this.http.post(query, null).pipe(map(x => x as BijwerkenResponse));
    }

    bijwerkenOproepEmailRelatie(id: Number, emailAdres: string) {        
        let query: string = `/api/dto/relatie/BijwerkenOproepEmailRelatie?relatieId=${id}&emailAdres=${emailAdres}`;
        return this.http.post(query, null).pipe(map(x => x as BijwerkenResponse));
    }

    bijwerkenDebiteurNummer(id: Number, nummer: number) {        
        let query: string = `/api/dto/relatie/BijwerkenDebiteurNummer?relatieId=${id}&exactNummer=${nummer}`;
        return this.http.post(query, null).pipe(map(x => x as BijwerkenResponse));
    }

    exporterenCentix(id: Number) {
        let query: string = `/api/dto/relatie/ExportRelatieCentix?relatieId=${id}`;
        return this.http.post(query, null).pipe(map(x => x as BijwerkenResponse));
    }

    ChangeCentixId(relatieId: number, centixId: number) {
        let query: string = `/api/dto/relatie/ChangeCentixId?relatieId=${relatieId}&centixId=${centixId}`;

        return this.http.post(query, null).pipe(map(x => x as BijwerkenResponse));

    }
    
    private convertFilter (f: Filter<Relatie>, arr: any[] = [] ) {
        for(let fp of f.getProperties()) {
            arr.push(fp);
        };

        let isEmpty = (str)=>typeof(str)=='string' && str.trim() == "";

        Object.keys(f).forEach(x => {
            if(Object.keys(new Filter<Relatie>()).indexOf(x) === -1 && f[x] != null && !isEmpty(f[x])) {
                let customProperty = {};
                customProperty[x] = f[x];
                arr.push(customProperty);
            }
        });

        f.filters.forEach(subF => {
            let andOrItem = {};
            let subArr = [];
            this.convertFilter(subF, subArr);
            andOrItem[subF.filterOperator == FilterOperator.And ? "and" : "or"] = subArr;
            arr.push(andOrItem);
        });

        return arr;
    }

    startMailingRelaties(relaties: Relatie[], subject: string, message: string) {

        let query: string = `api/mail/startMailing`;
        var myRelaties = [];

        relaties.forEach(relatie => {
            var r = new Relatie()
            r.id = relatie.id;
            r.naam1 = relatie.naam1;
            r.eMail = relatie.eMail;
            myRelaties.push(r);
        })

        subject = (subject != null && subject != undefined ? subject : "");
        message = (message != null && message != undefined ? message : "")

        let sendMailing: SendMailing = {
            relaties: myRelaties,
            subject: (subject != null && subject != undefined ? subject : ""),
            message: message.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/<p>/g, '').replace(/<\/p>/g, '<br>')
        };
                
        return this.http.post(query,sendMailing).pipe(map(x => x as SendMailingResponse));
    }
    
}

export class BijwerkenResponse {
    successful: boolean;
    message: string;
}

